import styled     from '@emotion/styled';
import { Button } from 'components/ui';

import { useState }            from 'react';
import ReactGA  from "react-ga4";
import ReactPixel from 'react-facebook-pixel';


const Elem:React.FC<any> = ({ showModal, closeModal }) =>{
  return (
    <>
      {showModal?
        <Background onClick={closeModal}>
          <ModalContainer onClick={e => e.stopPropagation()}>
            <TextConatinser>
              <BoldText className="top">3초만에 가입하고</BoldText>
              <BoldText className="bottom">인화구독을 체험해보세요!</BoldText>
              <SmallText>언제든 해지할 수 있으니 안심하세요!</SmallText>
            </TextConatinser>
            <ButtonContainer>
              <ButtonWrapper>
                <SelectButton 
                  onClick={closeModal}
                  >확인
                </SelectButton>
              </ButtonWrapper>
            </ButtonContainer>
          </ModalContainer>
        </Background>:null }
    </>
  )
};

export default Elem;

const Background = styled.div`
  position:fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0,0,0,0.50);
  z-index: 0;
`;
const ModalContainer = styled.div`
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  overflow: scroll;
  max-height: 80%;
  max-width: 343px;
  width: 100%;
  min-height: 231px;
  background-color: white;
  text-align: center;
  display:flex;
  flex-direction: column;
  
  border-radius: 10px;
  
  @media (max-width: 321px) {
    padding: 0 10px 0;
  }
`;
const TextConatinser = styled.div`
  /* max-width: 232px; */
  height: 93px;
  margin: 36px auto 0px;
  display: flex;
  flex-direction: column;
`
const BoldText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 133%;
  
  color: #000000;

  @media (max-width: 321px) {
    font-size:20px
  }

  &.top {
    /* margin-right: auto; */
  }

  &.bottom {
    /* margin-right: auto; */
    margin-top: 3px;
  }
`;
const SmallText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 133%;
  color: #7A7A7A;
  opacity: 0.7;
  /* margin-right: auto; */
  margin-top: 9px;
`;
const ButtonContainer = styled.div`
  width: 90%;
  height: 47px;
  margin: 33px auto 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const ButtonWrapper = styled.div`
  height: 100%;
  width: 100%;
`;

const SelectButton = styled.button`
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background-color: #DBC6A7;
  color: white;
`;